import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrSorttIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >

    <path
      d='M4.89982 12C5.28642 12 5.60001 11.6864 5.60001 11.2998V6.89941H6.10001C6.38306 6.89941 6.6381 6.72922 6.7465 6.46777C6.85481 6.2063 6.79515 5.90528 6.59513 5.70508L5.39494 4.50488C5.26366 4.37364 5.08545 4.2998 4.89982 4.2998C4.71427 4.29988 4.53591 4.37368 4.4047 4.50488L3.20548 5.70508C3.00531 5.90527 2.94481 6.20622 3.05314 6.46777C3.16142 6.72917 3.41672 6.8992 3.69962 6.89941H4.19962V11.2998C4.19962 11.6863 4.51335 11.9998 4.89982 12Z'
      fill='currentColor'
    />
    <path
      d='M11.3469 4.2998C11.7335 4.2998 12.0471 4.6134 12.0471 5V9.40039H12.5471C12.8302 9.40039 13.0852 9.57058 13.1936 9.83203C13.3019 10.0935 13.2423 10.3945 13.0422 10.5947L11.842 11.7949C11.7108 11.9262 11.5326 12 11.3469 12C11.1614 11.9999 10.983 11.9261 10.8518 11.7949L9.65259 10.5947C9.45241 10.3945 9.39191 10.0936 9.50024 9.83203C9.60853 9.57064 9.86383 9.40061 10.1467 9.40039H10.6467V5C10.6467 4.6135 10.9605 4.29996 11.3469 4.2998Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrSorttIconComponent;
